/** How this site advertises a page's URL. `canonical`, `hreflang`, `og:url` and every schema
 * `url`/`@id` have to agree, so both halves of the URL are resolved here and nowhere else. */

/** Set from SSM by `vite_env.sh` when deploying and by the dev-server, so it is only ever missing
 * in a build that is not going anywhere. Deliberately without a default: guessing an origin here
 * would let a misconfigured build advertise a plausible but wrong one — and on a white-label
 * domain, point every canonical at the wrong entity. */
export const siteOrigin = () => import.meta.env.VITE_INSTITUTIONAL_BASE_URI;

/** Prerendered pathnames arrive with a trailing slash; the advertised form never has one. */
export const canonicalPath = (pathname) => (pathname.endsWith('/') ? pathname.slice(0, -1) : pathname);
